import type { CourseAnalyticsProperties } from "@artha/types";

export const COURSE_ANALYTICS = {
  entityType: "course",
  cta: { enquire: "enquire", continue: "continue" },
} as const;

export const COURSE_ANALYTICS_PROPERTIES = [
  "entity_id",
  "course_type",
  "provider_name",
  "access_mode",
  "source_job_id",
  "is_demo",
  "position",
  "cta",
  "lead_id",
] as const satisfies readonly (keyof CourseAnalyticsProperties)[];
